import React from "react";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";
import { FacilityInventoryCalculationItemListTemplate } from "themes/application/facility-order/pages";
import { FacilityInventoryCalculationItemListViewStore } from "application/facility-order/stores";

@setCurrentView(rootStore => new FacilityInventoryCalculationItemListViewStore(rootStore), "facilityInventoryCalculationItemListViewStore")
@observer
class FacilityInventoryCalculationItemList extends React.Component {
    render() {
        return <FacilityInventoryCalculationItemListTemplate {...this.props} />;
    }
}

export default FacilityInventoryCalculationItemList;